export enum Severity {
  ERROR = 'error', WARN = 'warining', SUCCESS = 'success', INFO = 'info', DEBUG = 'debug'
}

export enum Duration {
  ERROR = 5000, WARN = 2000, SUCCESS = 3000, INFO = 3000, DEBUG = 0
}

export interface IMessage {
  code?: string;
  message: string;
  severity: string;
  action?: string;
  duration?: number;
}

export class Message implements IMessage {
  code?: string;
  message: string;
  severity: string;
  action?: string;
  duration: number;

  constructor(message: string, severity: string, code?: string, action?: string) {
    this.message = message;
    this.severity = `severity-${severity.toLowerCase()}`;
    this.duration = Duration[severity.toUpperCase()];
    this.code = code;
    this.action = (!action) ? 'X' : action;
  }

}
